import { useState } from "react";
import { API_ENDPOINTS } from '../../common';

export function ManageParticipation(
    interaction,
    setSendingParticipationState,
    sendingParticipationState,
    changerPage,
    changerAfficherMessageErreur,
    fetchResults,
    deviceId,
) {
    const [participation, setParticipation] = useState({
        channel_id: null,
        segment: null,
        device_id: localStorage.getItem('device_id'),
        extra_user_information: null,
        only_user_data: null,
        consent_gdpr: null,
        language: 'fr', // XXX
        author_app_user_id: null, // XXX
        content: {}, // Contenu de la participation
        textAnswer: '', // Réponse de type texte direct ou en témoinage
        voteValue: null, // Résultat d'un vote
        image: null,
        video: null
    });

    const updateParticipation = () => {
        participation.channel_id = interaction.channel_id;
        participation.segment = interaction.id;
        participation.only_user_data = interaction.game_type === 'registration';
    }
    /** Permet d'envoyer une participation texte vers l'API
     * 
     * 
     */
    const envoyerParticipationTexteVersAPI = async () => {
        // Si participation.id  ou participation.task_id est renseigné la sauvegarde a déjà été effectuée 
        // ne rien faire
        if (participation.id || participation.task_id || sendingParticipationState === 'sended') {
            return;
        }

        updateParticipation();
        // Check mandatory
        //let withError = await checkMandatoryFields();
        //if (withError)
        //    return;

        // Save exxtraUserInformation if asked or delete them
        // Sauvegarder les extraUserInformation si souhaitée sinon les supprimer
        //saveRemeberMe();

        // Update state
        // Mettre à jour l'avancement
        setSendingParticipationState("sending");
        // Build data to post
        // Construire les données à poster
        const data = participation;
        // Gestion des témoinage associé à un vote
        let content = {}
        if (participation.voteValue) {
            content = participation.voteValue;
        }
        content.text = participation.textAnswer;
        data.content = content
        // POST method is for text participation
        // POST est pour les participation text
        const response_data = await fetch(API_ENDPOINTS.interactions,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            }).then(response => {
                if (response.status >= 400) {
                    throw new Error("Server respond with error !");
                }
                else {
                    return response.json();
                }
            });
        if (response_data && response_data.task_id) {
            participation.task_id = response_data.task_id
        }
        // Update state
        // Mettre à jour l'avancement
        setSendingParticipationState("sended");
        interaction.asAlreadyVoted=true;
    };

    /** Permet d'envoyer un vote vers l'API
     * 
     */
    const envoyerParticipationVoteVersAPI = async () => {
        // Si participation.id  ou participation.task_id est renseigné la sauvegarde a déjà été effectuée 
        // ne rien faire
        if (participation.id || participation.task_id || sendingParticipationState === 'sended') {
            return;
        }
        updateParticipation();

        // TODO a conserver ici ?
        // Save exxtraUserInformation if asked or delete them
        // Sauvegarder les extraUserInformation si souhaitée sinon les supprimer
        //if (rememberMe)
        //    localStorage.setItem('extraUserInformation', JSON.stringify(extraUserInformation));
        //else
        //    localStorage.removeItem('extraUserInformation');
        // Update state
        // Mettre à jour l'avancement
        //setSendingParticipationState("sending");
        // Update progress bar
        // Mettre à jour la barre de progression
        //setProgress(80);
        // Build data to post
        // Construire les données à poster
        const data = participation;
        // Gestion des témoinage associé à un vote
        let content = {}
        if (participation.voteValue) {
            content = participation.voteValue;
        }
        content.text = participation.textAnswer;
        data.content = content

        var with_error = false;
        const response_data = await fetch(API_ENDPOINTS.interactions,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            }).then(response => {
                if (response.status >= 400) {
                    console.log(response);
                    with_error = true;
                }
                return response.json();
            });
        if (with_error) {
            //setSendingParticipationState("error");
            //setErrorMessage(response_data.message);
            await changerAfficherMessageErreur(true, response_data.message);
            return false;

        }
        else {
            // Récupérer les résultats
            await fetchResults();
            // Update state
            // Mettre à jour l'avancement
            setSendingParticipationState("sended");
        }
        // Update progress bar
        // Mettre à jour la barre de progression
        //setProgress(100);

        return true;
    }


    const asAlreadyVoted = async (interactionData) => {
        let with_error = false;

        const aldready_voted = await fetch(API_ENDPOINTS.alreadyVoted(interactionData.id, deviceId.current),
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(response => {
                if (response.status >= 400) {
                    with_error = true;
                }

                return response.json();
            });
        if (with_error) {
            return false;
        }

        interactionData.asAlreadyVoted = aldready_voted;
        return interactionData;
    }
    return {
        participation,
        updateParticipation,
        setParticipation,
        envoyerParticipationTexteVersAPI,
        envoyerParticipationVoteVersAPI,
        asAlreadyVoted,
    }
}